import { CaseType } from '@/types/generated'

export type CaseType =
  | 'API'
  | 'CHAT BOT'
  | 'QUESTIONNAIRE'
  | 'EMAIL'
  | 'MANUAL'
  | 'PHONE'
  | 'APPOINTMENT'

export const caseTypesDE = {
  [CaseType.API]: 'Schnittstelle',
  [CaseType.CHAT_BOT]: 'Chatbot',
  [CaseType.QUESTIONNAIRE]: 'Fragebogen',
  [CaseType.EMAIL]: 'E-Mail',
  [CaseType.MANUAL]: 'Manuell',
  [CaseType.PHONE]: 'Phonebot',
  [CaseType.APPOINTMENT]: 'Terminbuchung'
}

export const caseTypesEN = {
  [CaseType.API]: 'API',
  [CaseType.CHAT_BOT]: 'Chat Bot',
  [CaseType.QUESTIONNAIRE]: 'Questionnaire',
  [CaseType.EMAIL]: 'Email',
  [CaseType.MANUAL]: 'Manual',
  [CaseType.PHONE]: 'Phone Bot',
  [CaseType.APPOINTMENT]: 'Appointment'
}

export const caseTypesFR = {
  [CaseType.API]: 'API',
  [CaseType.CHAT_BOT]: 'Chatbot',
  [CaseType.QUESTIONNAIRE]: 'Questionnaire',
  [CaseType.EMAIL]: 'E-mail',
  [CaseType.MANUAL]: 'Manuel',
  [CaseType.PHONE]: 'Bot téléphonique',
  [CaseType.APPOINTMENT]: 'Rendez-vous'
}
